module.exports = __webpack_public_path__ + "static/img/landing2_05.85ba299.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/landing2_05.webp
// module id = q6c9
// module chunks = 0